import { render, staticRenderFns } from "./ForumChatMainThreads.vue?vue&type=template&id=49247116&scoped=true"
import script from "./ForumChatMainThreads.vue?vue&type=script&lang=js"
export * from "./ForumChatMainThreads.vue?vue&type=script&lang=js"
import style0 from "./ForumChatMainThreads.vue?vue&type=style&index=0&id=49247116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49247116",
  null
  
)

export default component.exports